module.exports = __webpack_public_path__ + "img/credit-card.27145e6c.png";